// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-box {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 20px 0px;
  gap: 30px;
}

.productive-bar {
  padding: 20px 0px;
  box-shadow: 1px solid rgba(0, 0, 0, 0.2);
  border: 1px solid #fff;
}
.productive-bar .bar-graph {
  height: 400px;
  width: 100%;
}

@media only screen and (max-width: 992px) {
  .chart-box {
    grid-template-columns: 1fr 1fr;
  }
}
@media only screen and (max-width: 768px) {
  .chart-box {
    grid-template-columns: 1fr;
  }
}
.date-input-box {
  padding: 8px;
  border: 1px solid #cdc4c4; /* Ensure full border control */
  border-radius: 6px;
  font-size: 14px;
  font-family: sans-serif;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: white;
  outline: none;
}

.date-input-box:focus {
  border-color: #4096ff; /* Ant Design blue or your primary color */
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.date-input-box::-webkit-calendar-picker-indicator {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/Main/MainPage.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kCAAA;EACA,iBAAA;EACA,SAAA;AACF;;AAEA;EACE,iBAAA;EACA,wCAAA;EACA,sBAAA;AACF;AAAE;EACE,aAAA;EACA,WAAA;AAEJ;;AAEA;EACE;IACE,8BAAA;EACF;AACF;AAEA;EACE;IACE,0BAAA;EAAF;AACF;AAGA;EACE,YAAA;EACA,yBAAA,EAAA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,uBAAA;EACA,aAAA;AADF;;AAIA;EACE,qBAAA,EAAA,0CAAA;EACA,6CAAA;AADF;;AAIA;EACE,eAAA;AADF","sourcesContent":[".chart-box {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  padding: 20px 0px;\n  gap: 30px;\n}\n\n.productive-bar {\n  padding: 20px 0px;\n  box-shadow: 1px solid rgba(0, 0, 0, 0.2);\n  border: 1px solid #fff;\n  .bar-graph {\n    height: 400px;\n    width: 100%;\n  }\n}\n\n@media only screen and (max-width: 992px) {\n  .chart-box {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .chart-box {\n    grid-template-columns: 1fr;\n  }\n}\n\n.date-input-box {\n  padding: 8px;\n  border: 1px solid #cdc4c4;   /* Ensure full border control */\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: sans-serif;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-color: white;\n  outline: none;\n}\n\n.date-input-box:focus {\n  border-color: #4096ff; /* Ant Design blue or your primary color */\n  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);\n}\n\n.date-input-box::-webkit-calendar-picker-indicator {\n  cursor: pointer;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
